// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"631b137b","453":"944b34be","732":"6b5f8730","977":"8e2fc34f"}[chunkId] + ".chunk.js";
};